module.exports = "data:image/svg+xml,%3Csvg width='13' height='12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.5.44l6.495 11.25H.005L6.5.44z' fill='%23148743'/%3E%3C/svg%3E"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg-icons/polygon-green.svg
// module id = 625
// module chunks = 1